<template>
  <div class="iv-difficult-declare iv-p-t-24">
    <div class="iv-main-width">
      <div class="iv-text-right iv-diff-add iv-p-b-8">
        <h1 style="float: left;" class="iv-main-color iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-12">廉洁证明申请</h1>
        <Button type="add" @click="addMember">廉洁证明申请</Button>
      </div>
      <List
        v-if="list.length > 0"
        :showPage="true"
        :list="list"
        :total="total"
        :current="currentPage"
        :pageSize="pageSize"
        @on-detail="onDetailPage" 
        @on-change="onChangePage"
        @on-page-size-change="onChangePageSize">
      </List>
      <NoData v-if="list.length <= 0"></NoData>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
  </div>
</template>

<script>
import List from './declare-list'
import NoData from '@/components/no-data'

export default {
  data () {
    return {
      list: [],
      spinShow: false,
      total: 0,
      currentPage: 1,
      pageSize: 5
    }
  },
  created () {
    this.getcertificateList()
  },
  methods: {
    // 获取申请列表
    getcertificateList () {
      this.spinShow = true
      this.$ajax({
        url: 'api-platform/honest/certificate/list',
        method: 'GET',
        data:{
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(({data}) => {
        this.list = data.data
        this.total = data.count
        this.spinShow = false
      })
    },
    // 列表右侧按钮
    onDetailPage (item, type) {
      if (type == 'update') { // 修改
        this.$router.push({
          name: 'certificationApply',
          query: {
            type: this.$encode('update'),
            certificateId: this.$encode(item.certificateId)
          }
        })
      } else if (type == 'delete') { // 删除
        this.$confirmModal.warning({
          title: this.tips?.reqText?.delTitle || '提示',
          content: this.tips?.reqText?.delContent || '是否确认删除？'
        }).then(res => {
          this.deleteCertificate(item.certificateId)
          res()
        })
      } else if (type == 'recall') { // 撤回
        this.$confirmModal.warning({
          title: this.tips?.reqText?.recallTitle || '提示',
          content: this.tips?.reqText?.recallContent || '是否确认撤回？'
        }).then(res => {
          this.recallCertificate(item.certificateId)
          res()
        })
      } else if (type == 'viewDetail') { // 查看详情
        this.$router.push({
          name: 'certificationApply',
          query: {
            type: this.$encode('viewDetail'),
            certificateId: this.$encode(item.certificateId)
          }
        })
      } else if (type == 'viewFeedback') { // 查看反馈信息
        this.$router.push({
          name: 'certificationFeedback',
          query: {
            certificateId: this.$encode(item.certificateId)
          }
        })
      }
    },
    // 表头新增
    addMember () {
      this.$router.push({
        name: 'certificationApply',
        query: {
          type: this.$encode('add')
        }
      })
    },
    // 删除申请
    deleteCertificate (certificateId) {
      this.$ajax({
        url: 'api-platform/honest/certificate/delete',
        method: 'DELETE',
        data:{
          certificateId
        }
      }).then(({data}) => {
        this.$Message.success('删除成功')
        this.getcertificateList()
      })
    },
    // 撤回申请
    recallCertificate (certificateId) {
      this.$ajax({
        url: 'api-platform/honest/certificate/recall',
        method: 'PUT',
        data:{
          certificateId
        }
      }).then(({data}) => {
        this.$Message.success('撤回成功')
        this.getcertificateList()
      })
    },
    onChangePage (page) {
      this.currentPage = page
      this.getcertificateList()
    },
    onChangePageSize (page) {
      this.pageSize = page
      this.getcertificateList()
    }
  },
  components: {
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
@import "variable/variable.scss";

.iv-difficult-declare {
  min-height: 100%;;
  background-color: #fff;
  .iv-diff-add {
    border-bottom: 1px dashed rgba(#000000, 0.15);
  }
  .iv-vertical-line::before {
    background: $iv-main-color
  }
}
</style>
